import { defineComponent as _defineComponent } from 'vue';
import { AccountCategory } from '~/types/types';
import { getTermsUrl } from '~/functions/accounts';
import EditUserDialog from '~/components/ix/dialog/EditUserDialog.vue';
import EditContextAccountDialog from '~/components/ix/dialog/EditContextAccountDialog.vue';
import BugReport from '~/components/BugReport.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderUserMenu',
  props: {
    canEditAccount: {
      type: Boolean,
      default: false
    },
    accountId: null,
    accountName: null,
    accountWebsite: null,
    accountLogo: null,
    accountType: null,
    accountDefaultReferencePeriods: null,
    accountRequireImpactSubmission: {
      type: Boolean
    },
    accountReportingPeriodType: null,
    locale: {
      default: 'en-US'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth;
    var editUserDialog = ref(false);
    var editAccountDialog = ref(false);
    var feedbackDialog = ref(false);
    var termsUrl = computed(function () {
      return getTermsUrl(props.locale);
    });
    var accountTypeLabel = computed(function () {
      if (props.accountType === AccountCategory.Portfolio) return 'Portfolio';
      if (props.accountType === AccountCategory.Venture) return 'Company';
      return 'Account';
    });
    var accountTypeIcon = computed(function () {
      if (props.accountType === AccountCategory.Portfolio) {
        return 'mdi-briefcase-account-outline';
      }
      if (props.accountType === AccountCategory.Venture) {
        return 'mdi-rocket';
      }
      return 'mdi-domain';
    });
    var editAccountTitle = computed(function () {
      return "Edit ".concat(accountTypeLabel.value.toLowerCase());
    });
    var logout = function logout() {
      sessionStorage.removeItem('impersonation_user_id');
      $auth.logout();
    };
    return {
      __sfc: true,
      props: props,
      $auth: $auth,
      editUserDialog: editUserDialog,
      editAccountDialog: editAccountDialog,
      feedbackDialog: feedbackDialog,
      termsUrl: termsUrl,
      accountTypeLabel: accountTypeLabel,
      accountTypeIcon: accountTypeIcon,
      editAccountTitle: editAccountTitle,
      logout: logout,
      EditUserDialog: EditUserDialog,
      EditContextAccountDialog: EditContextAccountDialog,
      BugReport: BugReport
    };
  }
});